'use client'

import { useEffect } from 'react'

import { ErrorPageContent } from '@/app/components/ErrorPageContent'
import { ErrorPageWrapper } from '@/app/components/ErrorPageWrapper'

export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <ErrorPageWrapper>
      <ErrorPageContent page={null} />
    </ErrorPageWrapper>
  )
}
